// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"pb","text":"pc","subText":"pd","toggleContainer":"pe","checked":"pf"};